module.exports = __webpack_public_path__ + "static/sdb-14d2e3fd4804c18d5592a0bd0f3a42ba.mp4";